var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "huge-icon/health/outline/medical information",
    clipPath: "url(#clip0_5408_530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3034",
    d: "M5.33337 7.33334V11.3333",
    stroke: "#4B5563",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3035",
    d: "M7.33337 9.33334H3.33337",
    stroke: "#4B5563",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3036",
    d: "M12.6666 8H9.33329",
    stroke: "#4B5563",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3037",
    d: "M11.3334 10.6667H9.33337",
    stroke: "#4B5563",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33337 4.00001H12C13.4728 4.00001 14.6667 5.19392 14.6667 6.66668V12C14.6667 13.4728 13.4728 14.6667 12 14.6667H4.00004C2.52728 14.6667 1.33337 13.4728 1.33337 12V6.66668C1.33337 5.19392 2.52728 4.00001 4.00004 4.00001H6.66671M9.33337 4.00001V2.66668C9.33337 1.9303 8.73642 1.33334 8.00004 1.33334C7.26366 1.33334 6.66671 1.9303 6.66671 2.66668V4.00001M9.33337 4.00001C9.33337 4.73639 8.73642 5.33334 8.00004 5.33334C7.26366 5.33334 6.66671 4.73639 6.66671 4.00001",
    stroke: "#4B5563",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5408_530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalInfo);
export default __webpack_public_path__ + "static/media/medical-info.b8886d07d03118629dab026ca974acc2.svg";
export { ForwardRef as ReactComponent };